import { render, staticRenderFns } from "./AlertLog.vue?vue&type=template&id=3b3e7f8d"
import script from "./AlertLog.vue?vue&type=script&lang=js"
export * from "./AlertLog.vue?vue&type=script&lang=js"
import style0 from "./AlertLog.vue?vue&type=style&index=0&id=3b3e7f8d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports